type TCurveSize = 'SMALL' | 'BIG'

const SIZES: { [key in TCurveSize]: string } = {
  SMALL: '10',
  BIG: '30',
}

const TopCurve = ({ size = 'BIG' }: { size?: TCurveSize }) => {
  return (
    <svg width={`${SIZES[size]}px`} height={`${SIZES[size]}px`} className="c-text-white">
      {/* M0,50 is the starting point
       * S 50 50, 50 0  is the curve (https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths#b%C3%A9zier_curves)
       * L50,50 is the last point */}
      <path
        d={`M0,${SIZES[size]} S ${SIZES[size]} ${SIZES[size]}, ${SIZES[size]} 0 L${SIZES[size]},${SIZES[size]} Z`}
        fill="currentColor"
      />
    </svg>
  )
}

const BottomCurve = ({ size = 'BIG' }: { size?: TCurveSize }) => {
  return (
    <svg width={`${SIZES[size]}px`} height={`${SIZES[size]}px`} className="c-text-white">
      <path
        d={`M0,0 L${SIZES[size]},0 L${SIZES[size]},${SIZES[size]} S ${SIZES[size]} 0, 0 0 Z`}
        fill="currentColor"
      />
    </svg>
  )
}

export { TopCurve, BottomCurve }
